import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import "component/modal/ExitDialog/styles.scss";

class ExitDialogModal extends Component {
  constructor(props) {
    super(props);
    this.onLeaveClickHandler = this._onLeaveClickHandler.bind(this);
    this.state = {
      hideModal: false,
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const { onClose } = this.props;
    if (this.modalRef && !this.modalRef.contains(event.target)) {
      onClose();
    }
  };

  _onLeaveClickHandler() {
    this.props.onLeaveClickHandler();
  }

  render() {
    const { t } = this.props;

    return (
      <div className="exit-container modal" role="dialog">
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          ref={(ref) => (this.modalRef = ref)}
        >
          <div className="modal-content">
            {
              <Fragment>
                <div className="modal-body">
                  <p>{t("doYouWantToLeave")}</p>
                </div>
                <div className="modal-footer d-none">
                  <span className="">
                    <button
                      type="button"
                      className="btn"
                      onClick={this.onLeaveClickHandler}
                    >
                      {t("leave")}
                    </button>
                  </span>
                  <span className="btn-mid">
                    <button
                      type="button"
                      className="btn"
                      onClick={() => {
                        this.props.broadcastSwitchDevice(this.props.params);
                      }}
                    >
                      {t("switchDevice")}
                    </button>
                  </span>
                  <span className="">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => {
                        this.props.onClose();
                      }}
                    >
                      {t("stay")}
                    </button>
                  </span>
                </div>
                <div className="modal-footer">
                  {this.props.switchDevice && (
                    <div className="row align-content-center stay">
                      <div className="col">
                        <button
                          type="button"
                          className="btn btn-danger text-nowrap  w-100"
                          onClick={() => {
                            this.props.onClose();
                          }}
                        >
                          {t("stay")}
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="row align-content-center">
                    {this.props.switchDevice ? (
                      <div className="col">
                        <button
                          type="button"
                          className="btn text-nowrap  w-100"
                          onClick={() => {
                            this.props.broadcastSwitchDevice(this.props.params);
                          }}
                        >
                          {t("switchDevice")}
                        </button>
                      </div>
                    ) : (
                      <div className="col">
                        <button
                          type="button"
                          className="btn btn-danger text-nowrap  w-100"
                          onClick={() => {
                            this.props.onClose();
                          }}
                        >
                          {t("stay")}
                        </button>
                      </div>
                    )}
                    <div className="col">
                      <button
                        type="button"
                        className="btn text-nowrap w-100"
                        onClick={this.onLeaveClickHandler}
                      >
                        {t("leave")}
                      </button>
                    </div>
                  </div>
                </div>
              </Fragment>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation("translation")(ExitDialogModal);
